import React from 'react'
import { AnnotatedMarkdown } from './Markdown'

export const DEFAULT_JR_CONTROLS_DISABLED_HTML_TAGS = ['a', 'img']
export const DEFAULT_DASHBOARD_DISABLED_HTML_TAGS = ['img']

/**
 * DashboardMarkdown - a markdown component which renders markdown on dashboard
 *
 * @param {Object} props - the react props
 * @param {string} props.children - the markdown to render
 * @param {string} props.className? - the css class names to apply to the markdown
 *
 * @returns {JSX.Element}
 */
export function DashboardMarkdown({
	children,
	className,
}: {
	children: string
	className?: string
}): JSX.Element {
	return (
		<AnnotatedMarkdown
			markdown={children}
			readOnly={true}
			disabledHtmlTags={DEFAULT_DASHBOARD_DISABLED_HTML_TAGS}
			className={className}
		/>
	)
}
